module.exports = __webpack_public_path__ + "img/employer_benefit_fraudprotection_mobile.33f1a671.jpg";